<div>
  <app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
    <app-lazy-tab [title]="'Website'">
      <app-components-specialist-customer-account-group-read-only *tabContent
        [customer]="customer"
        [customerAccountTypes]="website"
        [showBoostSiteAccounts]="true">
      </app-components-specialist-customer-account-group-read-only>
    </app-lazy-tab>
    <app-lazy-tab [title]="'SEO'">
      <app-components-specialist-customer-account-group-read-only *tabContent
        [customer]="customer"
        [customerAccountTypes]="seo">
      </app-components-specialist-customer-account-group-read-only>
    </app-lazy-tab>
    <app-lazy-tab [title]="'Blog'">
      <app-components-specialist-customer-account-group-read-only *tabContent
        [customer]="customer"
        [customerAccountTypes]="blog">
      </app-components-specialist-customer-account-group-read-only>
    </app-lazy-tab>
  </app-tab-panel>
</div>